import {useState, useEffect} from 'react';
import {isMobile} from "react-device-detect";
import {isObject, isUndefined} from 'lodash';
import {useLocation, useNavigate, useNavigation} from "react-router-dom";

import {isEmptyObj} from 'ultra/helpers/utils';

import Fab from '@mui/material/Fab';

import Skeleton from '@mui/material/Skeleton';
// import CloseIcon from '@mui/icons-material/Close';
// import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
// import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
// import MenuIcon from '@mui/icons-material/Menu';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import PersonIcon from '@mui/icons-material/Person';
import CloseIcon from '@mui/icons-material/Close';

import ShoppingCardButton from './Buttons/ShoppingCardButton'
import GlobalSearchNodeButton from './Buttons/GlobalSearchNodeButton'
import NodeManipulationsButton from './Buttons/NodeManipulationsButton'
import ShareButton from './Buttons/ShareButton'
import AddNodeButton from './Buttons/AddNodeButton'

import Slide from '@mui/material/Slide';

import DefaultImage from '../../Widgets/DefaultImage';

import GlobalSearch from '../../../../Components/GlobalSearch'

import {useShoppingStore} from '../../../../Stores/shopping';
import {useNavigationStore} from '../../../../Stores/navigation';
import {useGlobalCustomContext} from '../../../../Helpers/context';
import {getTelegramMode} from '../../../../Helpers/telegram';

import UserPic from '../../../Content/Components/UserPic';

import {USER_ACTIONS} from '../../../Profile/Reducers/user';
import {NODE_ACTIONS} from '../../Reducers/node';

import './index.scss'

export default function NodeActions(props) {
    const {config, content} = props;

    const [userActionsVisible, setUserActionsVisible] = useState(false);

    // const [showActions, setShowActions] = useState(false);

    const {cart} = useShoppingStore();

    const navigate = useNavigate();
    const navigation = useNavigation();
    const location = useLocation();

    const {contentLoading} = useNavigationStore();
    const {userState, userDispatch, nodeDispatch} = useGlobalCustomContext();

    useEffect(() => {
        if (navigation.state === 'loading') {
            setUserActionsVisible(false)
        }
    }, [navigation])

    const createNodes = config.permits.children.create;
    const createIdentifiedNodes = config.permits.identified.children.create;
    const ableToAdd = (createNodes?.length > 0) || (createIdentifiedNodes?.length > 0);

    const ableToUpdate = config.permits.update;
    const ableToDelete = config.permits.delete;
    const ableToValidate = config.permits.validate

    let hasManipulationButtons = false
    if (ableToUpdate || ableToDelete || ableToValidate) hasManipulationButtons = true

    let visibleButtonsOnMobile = 1 // share button
    if (location.pathname !== "/") visibleButtonsOnMobile += 1
    if (cart?.length > 0) visibleButtonsOnMobile += 1
    if (ableToAdd) visibleButtonsOnMobile += 1
    if (hasManipulationButtons) visibleButtonsOnMobile += 1

    if (userState?.userLoginInProgress) return <div className='actionsList'>
        <div className='actionsListButtons'>
            <Skeleton variant="rectangular" width={56} height={56} style={{
                borderRadius: '15px',
                display: 'inline-flex',
                marginLeft: '0.5rem'
            }} />
        </div>
    </div>

    const goHome = () => {
        navigate('/')
    }

    const goBack = () => {
        window.history.back();
    }

    const isRootPage = window.location.pathname === '/'

    const showUserActions = () => {
        setUserActionsVisible(!userActionsVisible)
    }

    const closeUserActions = () => {
        setUserActionsVisible(false)
    }

    return <div className='actionsList'>
        <div className={`actionsListButtons ${userActionsVisible ? "userActionsVisible" : ""}`}>
            {/* <div className="block">
                    {isMobile && <Fab
                        className='goBackButton'
                        // color="neutral"
                        onClick={goBack}>
                            <KeyboardArrowLeftIcon />
                    </Fab>}
                </div> */}
            {/* <div className="left">
                {isMobile && (window.history.length > 1 || !isRootPage) && <div className="block">
                    <Fab
                        className='goBackButton'
                        // color="neutral"
                        onClick={goBack}>
                            <KeyboardArrowLeftIcon />
                    </Fab>
                    {!isRootPage && <Fab
                        // color="neutral"
                        onClick={goHome}>
                            <HomeOutlinedIcon />
                    </Fab>}
                </div>}
            </div> */}

            {isMobile && <div className="center">
                <GlobalSearch />
            </div>}

            <div className="right">
                {cart?.length > 0 && <div className="block"><ShoppingCardButton disabled={contentLoading} /></div>}

                {ableToAdd && <div className="block"><AddNodeButton
                    parent={config?.page?.content._uri}
                    nodes={createNodes}
                    identifiedNodes={createIdentifiedNodes}
                    childrenOptions={config.page?.config?.childrenOptions}
                /></div>}

                <div className="prostir block">
                    {(userActionsVisible || !isMobile) && <>
                        {isMobile && <ShareButton did={content._did} title={content.title} />}

                        {!isRootPage && <Fab
                            onClick={goHome}>
                                <HomeOutlinedIcon />
                        </Fab>}

                        {!isMobile && <GlobalSearchNodeButton />}

                        {/* showAdd={ableToAdd && visibleButtonsOnMobile >= 5} */}
                        <NodeManipulationsButton config={config} content={content} />

                        {isMobile && 
                            <Fab>
                                <UserPic/>
                            </Fab>
                        }
                    </>}

                    {userActionsVisible && <Fab
                        className='closeIcon'
                        // color="neutral"
                        onClick={closeUserActions}
                    >
                        <CloseIcon />
                    </Fab>}
                    
                    {isMobile && !userActionsVisible && <DefaultImage
                        className="logoImg"
                        image={`config/images/logo.png`}
                        onClick={showUserActions}
                    />}
                </div>
            </div>
        </div>
    </div>
}
